<template>
  <div>
    <Header :breadcrumsfirst="breadcrumsfirst" :breadcrumslast="breadcrumslast" />
    <Subheader :title="`${networkId ? 'Edit' : 'Add New'} Network`" />
    <div class="container">
      <div class="row py-3">
        <div class="col-md-3">
          <div class="form-group">
            <label for="networktypeid" class="custom-label">ID</label>
            <input id="networktypeid" type="text" class="form-control shadow-none custom-input"
              placeholder="This is autogenerated" readonly v-model="saveData.id">
          </div>
        </div>
        <div class="col-md-9 mb-4">
          <div class="form-group">
            <label for="networkTypeName" class="custom-label">Title</label>
            <input id="networkTypeName" class="form-control shadow-none custom-input" placeholder="Enter text"
              v-model="saveData.title">
          </div>
        </div>
        <div class="col-md-12 mb-3">
          <div class="form-check form-check-inline">
            <input class="form-check-input shadow-none" type="radio" name="inlineRadioOptions" id="inlineRadio1"
              :value=1 v-model.number="saveData.isworkload">
            <label class="form-check-label custom-label" for="inlineRadio1">Workload</label>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input shadow-none" type="radio" name="inlineRadioOptions" id="inlineRadio2"
              :value=1 v-model.number="saveData.isuser">
            <label class="form-check-label custom-label" for="inlineRadio2">User</label>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input shadow-none" type="radio" name="inlineRadioOptions" id="inlineRadio2"
              :value=1 v-model.number="saveData.isother">
            <label class="form-check-label custom-label" for="inlineRadio2">Other</label>
          </div>

        </div>
        <!-- <div class="col-md-3 mb-3">
            <div class="form-group">
              <label class="custom-label">Network Type</label>
              <select class="form-select form-control shadow-none custom-input custom-dropdown" id="autoSizingSelect" v-model="saveData.networktypeid">
                <option v-for="networkType in networkTypes" :key="networkType.uuid" :value="networkType.uuid">{{ networkType.name }}</option>
              </select>
            </div>
          </div> -->
        <div class="row align-items-center">
          <div class="col-md-3 mb-3">
            <div class="form-group">
              <label class="custom-label">Network Type</label>
              <div class="custom-multiple-dropdown-wrapper">
                <select class="form-select form-control shadow-none custom-input custom-dropdown" id="autoSizingSelect"
                  v-model="saveData.networktypeid">
                  <option value="" disabled selected>Select Option</option> <!-- Placeholder option -->
                  <option v-for="networkType in networkTypes" :key="networkType.uuid" :value="networkType.uuid">{{
                    networkType.name }}</option>
                </select>
                <button @click="updateSelectedNetworkTypes(saveData.networktypeid)"
                  class="multiple-dropdown-add-button">+</button>
              </div>
            </div>
          </div>

          <div class="col-md-9 mb-3 align-self-end custom-input">
            <div v-if="selectedNetworkTypes.length > 0" class="custom-multiple-dropdown-container">
              <div v-for="(networkType, index) in selectedNetworkTypes" :key="index">
                <span class="custom-multiple-dropdown">{{ networkType }}
                  <button class="multiple-dropdown-delete-icon" @click="removeSelectedNetworkType(index)">
                    <dropdownDeleteIcon />
                  </button>
                </span>
              </div>
            </div>
          </div>
          <small v-if="selectedNetworkTypes.length === 0" class="text-danger"
            style="margin-top: -10px; font-size: 11px;">Select network type</small>
        </div>
        <div class="col-md-12 mb-3">
          <div class="form-group">
            <label for="networkTypeDesc" class="custom-label">Description</label>
            <input id="networkTypeDesc" class="form-control shadow-none custom-input" placeholder="Enter text"
              v-model="saveData.description">
          </div>
        </div>
        <div class="col-md-12 mb-3">
          <div class="form-group">
            <label for="networkTypeNote" class="custom-label">Notes</label>
            <textarea id="networkTypeNote" class="form-control shadow-none custom-input" rows="4"
              placeholder="Enter text" v-model="saveData.note"></textarea>
          </div>
        </div>
        <div class="col-md-3" v-if="this.networkId">
          <div class="form-group">
            <button type="button" class="btn btn-danger btn-sm delete-button" data-bs-toggle="modal"
              data-bs-target="#exampleModal">Delete</button>
          </div>
        </div>
        <deleteModal v-if="this.networkId" :deleteRecord="deleteRecord" />
        <div class="col-md-8 d-flex justify-content-end" v-if="this.networkId">

          <div class="form-group">
            <button type="button" class="btn btn-secondary btn-sm cancel-button" @click="cancelButton()">Cancel</button>
          </div>
        </div>
        <div class="col-md-11 d-flex justify-content-end" v-else>
          <div class="form-group">
            <button type="button" class="btn btn-secondary btn-sm cancel-button" @click="cancelButton()">Cancel</button>
          </div>
        </div>
        <div class="col-md-1 d-flex justify-content-start">
          <div class="form-group">
            <button type="submit" class="btn btn-primary btn-sm submit-button" :disabled="isSubmitDisabled"
              @click="addnetworkData()">Submit</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Subheader from '@/components/Subheader.vue'
import { ddNetworkType, addNetwork, getByIdNetwork, updateNetwork } from '@/http/iot-asset/network.http'
import deleteModal from '@/components/delete-modal.vue';
import dropdownDeleteIcon from '@/components/dropdown-delete-icon.vue';
export default {
  name: 'network-form',
  components: {
    Header,
    Subheader,
    deleteModal,
    dropdownDeleteIcon
  },
  data() {
    return {
      breadcrumsfirst: "IoT Assets",
      breadcrumslast: "Network",
      networkId: this.$route.params.id,
      saveData: {
        isworkload: 0,
        isuser: 0,
        isother: 0,
        networktypeid: ''
      },
      networkTypes: [],
      selectedNetworkTypes: []
    }
  },
  mounted() {
    this.getNetworkTypeDropdownData()
      .then(() => {
        return this.getDetailData();
      })
      .catch(error => {
        console.error('Error mounting component:', error);
      });

  },
  computed: {
    isSubmitDisabled() {
      return this.selectedNetworkTypes.length === 0;
    }
  },
  watch: {
    'saveData.isworkload': function (newVal) {
      if (newVal === 1) {
        // If Asset Entry is selected, set Catalog Enable to 0
        this.saveData.isuser = 0;
        this.saveData.isother = 0;
      }
    },
    'saveData.isuser': function (newVal) {
      if (newVal === 1) {
        this.saveData.isworkload = 0;
        this.saveData.isother = 0;
      }
    },
    'saveData.isother': function (newVal) {
      if (newVal === 1) {
        this.saveData.isworkload = 0;
        this.saveData.isuser = 0;
      }
    }
  },
  methods: {
    addnetworkData() {
      if (this.networkId) {
        const payload = {
          uuid: this.$route.params.id,
        };
        const selectedNetworkTypeIds = this.selectedNetworkTypes.map(networkTypeName => {
          const networkType = this.networkTypes.find(networkType => networkType.name === networkTypeName);
          return networkType ? networkType.uuid : null;
        }).filter(Boolean).join(',');

        // Assign selected asset type IDs to saveData
        this.saveData.networktypeid = selectedNetworkTypeIds;
        updateNetwork({ ...payload, ...this.saveData }).then(() => {
          this.saveData.updatedon = new Date().toISOString();
          this.$router.push("/iotassets/network")
        }).catch((error) => {
          this.error = error.message;
        });
      } else {
        const selectedNetworkTypeIds = this.selectedNetworkTypes.map(networkTypeName => {
          const networkType = this.networkTypes.find(networkType => networkType.name === networkTypeName);
          return networkType ? networkType.uuid : null;
        }).filter(Boolean).join(',');

        // Assign selected asset type IDs to saveData
        this.saveData.networktypeid = selectedNetworkTypeIds;
        addNetwork(this.saveData).then(() => {
          this.$router.push("/iotassets/network")
        }).catch((error) => {
          this.error = error.message;
        });
      }

    },
    updateSelectedNetworkTypes(networkTypeId) {
      const networkType = this.networkTypes.find(networkType => networkType.uuid === networkTypeId);
      if (networkType && !this.selectedNetworkTypes.includes(networkType.name)) {
        this.selectedNetworkTypes.push(networkType.name);
      }
    },
    removeSelectedNetworkType(index) {
      this.selectedNetworkTypes.splice(index, 1);
    },

    async getNetworkTypeDropdownData() {
      try {
        this.networkTypes = await ddNetworkType();
      } catch (error) {
        console.error('Error fetching network :', error);
        throw error;
      }
    },
    async getDetailData() {
      try {
        if (this.networkId) {
          const response = await getByIdNetwork(this.networkId);
          this.saveData = response;

          if (Array.isArray(response.networktypeid) && response.networktypeid.length > 0) {
            this.selectedNetworkTypes = response.networktypeid.map(networkTypeId => {
              const networkType = this.networkTypes.find(type => type.uuid === networkTypeId);
              return networkType ? networkType.name : '';
            });
            this.saveData.networktypeid = '';
          } else {
            this.saveData.networktypeid = '';
          }
        }
      } catch (error) {
        console.error('Error fetching network details:', error);
        throw error;
      }
    },
    cancelButton() {
      this.$router.push("/iotassets/network")
    },
    deleteRecord() {
      this.saveData.issoftdelete = 1;
      const payload = {
        issoftdelete: this.saveData.issoftdelete ? 1 : 0,
        uuid: this.$route.params.id,
      };
      const selectedNetworkTypeIds = this.selectedNetworkTypes.map(networkTypeName => {
        const networkType = this.networkTypes.find(networkType => networkType.name === networkTypeName);
        return networkType ? networkType.uuid : null;
      }).filter(Boolean).join(',');

      // Assign selected asset type IDs to saveData
      this.saveData.networktypeid = selectedNetworkTypeIds;
      updateNetwork({ ...payload, ...this.saveData }).then(() => {
        this.saveData.updatedon = new Date().toISOString();
        this.$router.push("/iotassets/network")
      }).catch((error) => {
        this.error = error.message;
      });

    },
  }
}
</script>

<style scoped></style>